<template>
  <b-card class="message">
    <div class="text-center">
      <b-icon icon="inbox" font-scale="3" animation="fade"></b-icon>

      <div v-html="modeView()" />
      </div>
  </b-card>
</template>

<script>
/**
 * @file       Empty comment component.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import { commentsMixin } from "@/modules/comments/mixins.js";

/**
 * Export the component.
 * 
 * @type  {Object}
 */
export default {
  mixins: [commentsMixin],

  /**
   * Methods.
   * 
   * @type  {Object}
   */
  methods: {
    /**
     * Mode view.
     * 
     * @return   {String}   HTML when empty
     */
    modeView() {
      if (this.isFilter) {
        return this.isFlaggedFilter
          ? "<h3>aucun message signalé</h3>"
          : "<h3>Aucun commentaire trouvé</h3>";
      }
      if (this.routeIsSuggestion) {
        return "<h3>Pas de suggestion</h3>";
      }
      if (this.routeIsMessages) {
        return `<h3>Pas de messages</h3>`;
      }
      return `<h3>Cette délibération ne contient pas de message.</h3> <p>  Sois le premier à t'exprimer sur le sujet. </p>`;
    }
  }
};
</script>

<style lang="scss" scoped></style>
